import { GameChangeEvent } from '../../models/communication/app-state.model';
import { GameBase } from '../game-base';
import { GameFlowBase } from '../game-flow-base';

export const classicGameStateNames = ['START', 'DRAW-AND-PLACE-CARD', 'OUTCOME'] as const;
export type ClassicGameStateName = (typeof classicGameStateNames)[number];

export class ClassicGameFlow extends GameFlowBase<GameBase, GameChangeEvent, ClassicGameStateName> {
    protected override stateNames = classicGameStateNames;

    onChange({ action, data }: GameChangeEvent): void {
        switch (this.getState()) {
            case 'START': {
                this.game.showFaceUpMessage(this.game.getFirstCardPosition());
                this.nextState();

                break;
            }

            case 'DRAW-AND-PLACE-CARD': {
                if (action === 'tableChange') {
                    this.game.showCard(data.cardPosition, data.card);
                    this.game.showHandValue(data);

                    if (data.nextCardPosition === undefined) {
                        this.nextState();
                    } else {
                        this.game.showFaceUpMessage(data.nextCardPosition);
                    }
                }

                break;
            }

            case 'OUTCOME': {
                if (action === 'tableChange') {
                    this.game.handleOutcome(data);
                }
            }
        }
    }
}
